import styled from "@emotion/styled";
import { Stack, Typography } from "@mui/material";
import { Container } from "@/globalStyles";

export const PageWrapper = styled(Container)`
    padding-top: 24px;
    padding-bottom: 24px;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding-top: 16px;
        padding-bottom: 16px;
    }
`;

export const Description = styled(Typography)`
    color: ${({ theme }) => theme.colors.text.secondary};
`;

/** Composer on the left, live preview on the right; stacks on narrow screens. */
export const SplitLayout = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 24px;
    align-items: start;

    @media (max-width: 1100px) {
        grid-template-columns: minmax(0, 1fr);
    }
`;

export const Panel = styled.div`
    min-width: 0;
    background: rgba(41, 56, 77, 0.55);
    border: 1px solid rgba(128, 149, 183, 0.18);
    border-radius: 8px;
    padding: 20px;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 16px;
    }
`;

export const PanelHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 16px;
    min-width: 0;
`;

/**
 * The email itself. White background on purpose — the layout renders on the recipient's
 * mail client, not on the dashboard's dark chrome, so previewing it on dark would lie.
 */
export const PreviewFrame = styled.iframe`
    width: 100%;
    height: 620px;
    border: 1px solid rgba(128, 149, 183, 0.18);
    border-radius: 6px;
    background: #ffffff;
    display: block;
`;

export const PreviewPlaceholder = styled.div`
    height: 620px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 24px;
    border: 1px dashed rgba(128, 149, 183, 0.3);
    border-radius: 6px;
    color: ${({ theme }) => theme.colors.text.secondary};
`;

export const CharCount = styled.span`
    font-size: 12px;
    color: ${({ $overLimit, theme }) =>
        $overLimit ? "#e5484d" : theme.colors.text.secondary};
    font-variant-numeric: tabular-nums;
`;

export const Actions = styled(Stack)`
    flex-wrap: wrap;
`;

/** Red-tinted panel around the irreversible "send to everyone" control. */
export const DangerZone = styled.div`
    margin-top: 24px;
    border: 1px solid rgba(229, 72, 77, 0.45);
    border-radius: 8px;
    padding: 20px;
    background: rgba(229, 72, 77, 0.06);

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 16px;
    }
`;

export const HintList = styled.ul`
    margin: 8px 0 0;
    padding-left: 18px;
    color: ${({ theme }) => theme.colors.text.secondary};
    font-size: 13px;
    line-height: 1.6;

    code {
        font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
        background: rgba(128, 149, 183, 0.18);
        border-radius: 3px;
        padding: 1px 5px;
    }
`;
